import { WorkstationTypes } from "../Constants";

export const mapWorkstationToSize = (id: number): string => {
  switch (id) {
    case 101:
      return "S";
    case 102:
      return "M";
    case 104:
      return "L";
    case 108:
      return "XL";
    case 116:
      return "MAN";
    case 132:
      return "S Väst";
    case 164:
      return "M Väst";
    case 999:
      return "A";
    default:
      return id.toString();
  }
};

export const getWorkstationTypeString = (workstationType: number): string => {
  switch (workstationType) {
    case WorkstationTypes.AutoPackMixedSmall:
    case WorkstationTypes.AutoPackWestMixedSmall:  
      return "S";
    case WorkstationTypes.AutoPackMixedMedium:
    case WorkstationTypes.AutoPackWestMixedMedium:  
      return "M";
    default:
      return "";
  }
};
